import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { setOpenWinnerModal } from '../../../../../lib/redux/campaignPrize/campaignPrizeSlice';

import { Container, ErrorMsg } from './StyledComponents';

import Text from '../../../../../shared/Text';
import { ButtonBase } from '../../../../../shared/Button';

const FinishedBanner = ({ header, description, btnIcon, btnText }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('posts');
  const hasError = useSelector(state => state.campaignPrize.hasError);

  return (
    <OuterWrapper className={hasError ? 'shakeX' : ''} $hasError={hasError}>
      <Wrapper>
        <Content>
          <Header as="div" variant="h5">
            {header}
          </Header>
          <Description as="div" variant="subtitle2">
            {description}
          </Description>
          <ErrorMsg as="div" variant="subtitle2" $hasError={hasError}>
            {t('prizeBanner.errors.noWinners')}
          </ErrorMsg>
        </Content>
        <PickEditWinnerBtn
          mode="contained"
          variant="primary"
          onClick={() => dispatch(setOpenWinnerModal())}
        >
          {btnIcon}
          {btnText}
        </PickEditWinnerBtn>
      </Wrapper>
    </OuterWrapper>
  );
};

export default FinishedBanner;

const OuterWrapper = styled(Container)`
  padding: 20px 23px 20px 20px;
  height: ${props => (props.$hasError ? '110px' : '88px')};
  ${props =>
    props.$hasError
      ? `background: linear-gradient(
          0deg, #FFF4F3 0%, #FFF4F3 100%),
          radial-gradient(
            347.82% 69.04% at 15.94% 50%,
            rgba(132, 153, 246, 0.10) 0%,
            rgba(237, 166, 138, 0.10) 100%
          );
        `
      : `background: linear-gradient(
            0deg,
            rgba(132, 153, 246, 0.2) 0%,
            rgba(132, 153, 246, 0.2) 100%
          ),
          #fff;
      `}
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Content = styled.div``;

const Header = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
`;

const Description = styled(Text)``;

const PickEditWinnerBtn = styled(ButtonBase)``;
